<template>

<div class="screen" v-is:central="isCentral" v-is:report="isReport">

    <sidebar v-if="isReport" />

    <icon n="loading" v-if="isLoading" class="screen-loading" />

    <div class="screen-content">

        <div class="screen-title" v-if="title">{{ title }}</div>
	
        <slot></slot>

    </div>

</div>

</template>

<script>

export default {
	
    props: ['isCentral', 'isLoading', 'isReport', 'title']

}

</script>

<style scoped>

.screen {
    position: fixed;
    left: 0px;
    top: 0px;
    right: 0px;
    bottom: 0px;
    overflow: auto;
}

.screen.is-central {
    display: flex;
    justify-content: safe center;
    align-items: safe center;
    padding: 40px;
}

.screen.is-report {
    background-color: #F9F9F9;
    padding: 40px 64px 40px 168px;
}

.screen-title {
    color: #050505;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 64px;
}

.screen-loading {
    position: absolute;
    left: 50%;
    top: 50%;
    color: #14C6A4;
    font-size: 32px;
}

</style>
